export default function authHeader() {
    const user = JSON.parse(sessionStorage.getItem('auth'));
    if (user && user.accessToken) {
        return 'Bearer ' + user.accessToken;
    } else {
        return {};
    }
}